/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingloadmore2Inputs */

const en_crosspostingloadmore2 = /** @type {(inputs: Crosspostingloadmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

const de_crosspostingloadmore2 = /** @type {(inputs: Crosspostingloadmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr laden`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Crosspostingloadmore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingloadmore2 = /** @type {((inputs?: Crosspostingloadmore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingloadmore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingloadmore2(inputs)
	return de_crosspostingloadmore2(inputs)
});
export { crosspostingloadmore2 as "crosspostingLoadMore" }